import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import sourceflowEnums from "@/sourceflow.enums";

import { router } from "@/routes";

export { default } from 'pages/blog'

export async function getStaticProps() {
    const global = (await Global()).toJson();

    const blogs = (await Collection(`events`))
        .filter(post => {
            // Event value id
            return post?.blog_category.en.includes("99fb1780-6d53-482f-9f68-41dd8822d807");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const blog_tags = (await Collection(`blog_tags`)).getItems()
    const blog_category = (await Collection(`blog_category`)).getItems()

    const routerKey = "events";
    return {
        props: {
            global,
            blogs,
            blog_category,
            blog_tags,
            meta: {
                title: "Events | Tradewind Subs",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search